﻿export interface IRecipientVoucher{
      adpFirstName: string,
      adpLastName: string,
      adpAddress: string,
      adpCity: string,
      adpState: string,
      adpPostalCode: string,
      adpPhonePrimary: string,
      adpPhoneSecondary: string,
      adpEmailPrimary: string, 
      adpEmailSecondary: string
}
